export const hasMutation = (content, language) => {
  const slug = content.slug;
  if (slug[language]) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/AboutList/utils.js